import { noop } from 'lodash';
import React, {
  FC,
  PropsWithChildren,
  createContext,
  useContext,
  useState,
} from 'react';
import { SendMessage } from './use-websocket';

type SendSocketMessageCtx = {
  sendMessage: SendMessage | null;
  setSendMessage: React.Dispatch<React.SetStateAction<SendMessage | null>>;
};

const defaultCtx: SendSocketMessageCtx = {
  sendMessage: null,
  setSendMessage: noop,
};

const SocketMessageCtx = createContext(defaultCtx);

export const useSendSocketMessage = () => useContext(SocketMessageCtx);

export const SendWSMessageProvider: FC<PropsWithChildren> = ({ children }) => {
  const [sendMessage, setSendMessage] = useState<SendMessage | null>(null);

  return (
    <SocketMessageCtx.Provider
      value={{
        sendMessage,
        setSendMessage,
      }}
    >
      {children}
    </SocketMessageCtx.Provider>
  );
};
